import { FC } from 'react'
import { Tooltip, ITooltip } from 'react-tooltip'

export type ReactTooltipProps = ITooltip

/**
 * ```
 * import { ReactTooltip } from '@/components/Tooltip/ReactTooltip'
 * ```
 *
 * A tooltip component that uses the react-tooltip library.
 *
 * ```
 * <div
 *  data-tooltip-id='tooltip'
 *  data-tooltip-content='This is a tooltip'
 * >
 *  <Button />
 * </div>
 * <ReactTooltip id='tooltip' place='top' />
 * ```
 */

const ReactTooltip: FC<ReactTooltipProps> = ({
  id = '',
  className = 'z-9999 text-xs! text-white! px-4! py-2! bg-primary! border border-primary-border',
  place = 'top',
  offset = 12,
  delayShow = 50,
  delayHide = 0,
  ...rest
}) => {
  return (
    <Tooltip
      id={id}
      className={className}
      place={place}
      offset={offset}
      delayShow={delayShow}
      delayHide={delayHide}
      {...rest}
    />
  )
}

export default ReactTooltip
